import React from "react";
import RecipeActions from "./RecipeActions";
interface Props {
  productName?: string;
  dirty: boolean;
  loaded: boolean;
  hasRecipe: boolean;
  canManage: boolean;
  saving: boolean;
  loading: boolean;
  conflict: boolean;
  onRemove: () => void;
}
export default function RecipeHeader({
  productName,
  dirty,
  loaded,
  hasRecipe,
  canManage,
  saving,
  loading,
  conflict,
  onRemove,
}: Props) {
  const status = dirty ? "Unsaved changes" : hasRecipe ? "Saved" : "Draft";
  return (
    <div className="flex items-start justify-between gap-3 border-b border-slate-100 px-4 py-4 sm:px-5">
      <div className="min-w-0">
        <div className="flex flex-wrap items-center gap-2">
          <h2 className="text-base font-semibold text-slate-900">
            {productName ? `Recipe for ${productName}` : "Recipe"}
          </h2>
          {loaded && (
            <span
              className={`rounded-full px-2 py-0.5 text-xs font-medium ${
                dirty
                  ? "bg-amber-50 text-amber-800"
                  : "bg-slate-100 text-slate-500"
              }`}
            >
              {status}
            </span>
          )}
        </div>
        <p className="mt-1 text-xs text-slate-500">
          Ingredient quantities per output batch.
        </p>
      </div>
      {loaded && hasRecipe && canManage && (
        <RecipeActions
          disabled={saving || loading || conflict}
          onRemove={onRemove}
        />
      )}
    </div>
  );
}
